// Remembers, per browser, that a tour was finished. Storage can be missing or
// blocked; the tour then simply offers itself again.
export const tourSeen = key => {
  try {
    return window.localStorage.getItem(`relay-tour:${key}`) === 'done';
  } catch {
    return false;
  }
};

export const markTourSeen = key => {
  try {
    window.localStorage.setItem(`relay-tour:${key}`, 'done');
  } catch {
    // Not remembered; harmless.
  }
};
